var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon9C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 7.99023C5.0625 8.6367 5.31931 9.25668 5.77643 9.7138C6.23355 10.1709 6.85353 10.4277 7.5 10.4277C8.14646 10.4277 8.76645 10.1709 9.22357 9.7138C9.68069 9.25668 9.9375 8.6367 9.9375 7.99023C9.9375 7.34377 9.68069 6.72378 9.22357 6.26666C8.76645 5.80954 8.14646 5.55273 7.5 5.55273C6.85353 5.55273 6.23355 5.80954 5.77643 6.26666C5.31931 6.72378 5.0625 7.34377 5.0625 7.99023Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0963 12.5863L8.64887 16.0337C8.34418 16.3381 7.9311 16.5091 7.50041 16.5091C7.06971 16.5091 6.65664 16.3381 6.35194 16.0337L2.90369 12.5863C1.99468 11.6772 1.37565 10.5191 1.12487 9.25819C0.874097 7.99733 1.00284 6.69041 1.49482 5.50271C1.9868 4.31501 2.81992 3.29987 3.88883 2.58566C4.95774 1.87144 6.21444 1.49023 7.5 1.49023C8.78556 1.49023 10.0423 1.87144 11.1112 2.58566C12.1801 3.29987 13.0132 4.31501 13.5052 5.50271C13.9972 6.69041 14.1259 7.99733 13.8751 9.25819C13.6243 10.5191 13.0053 11.6772 12.0963 12.5863Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon9C);
export default __webpack_public_path__ + "static/media/location_icon_9c.fe5d978dd5b89b7d289cab284a24a922.svg";
export { ForwardRef as ReactComponent };